import styled from '@emotion/styled';
import Container from '@ep/components/Container';
import TextField from '@ep/components/TextField';
import theme from '@ep/theme';
import { __EnumValue } from 'graphql';
import React, { useState } from 'react';

const StyledContainer = styled(Container)`
  display: grid;
  max-width: 80rem;
  ${theme.mediaQueries.desktop} {
    grid-template-columns: repeat(2, 1fr) !important;
  }
  ${theme.mediaQueries.mobileAndTablet} {
    grid-template-columns: repeat(1, 1fr) !important;
  }
  #content {
  }
  #controls {
    margin: 0rem auto;
  }
  #controlsInner {
  }
  .option {
    min-height: 8.7rem;
  }
  #results {
    margin: 0rem auto;
  }
  #resultsInner {
  }
  #bottom {
    grid-column: 1 / span 2;
    ${theme.mediaQueries.mobileAndTablet} {
      grid-column: 1 / span 1;
    }
  }
  h1 {
    margin-top: 5rem;
    font-family: ${theme.typography.primaryFont.bold};
    color: ${theme.colors.duskBlue};
    font-size: 1.8rem;
  }
  hr {
    border: 0px solid white;
    border-top: 0.5px solid ${theme.colors.gray};
    margin-bottom: 2rem;
  }
  td {
    vertical-align: top;
  }
  input,
  p,
  select {
    margin-top: 1rem;
    font-size: 1.2em;
    padding: 10px;
    border-radius: 10px;
  }
  select {
    width: 33.5rem;
    border: 1px solid ${theme.colors.gray};
    margin-bottom: 8rem;
    padding: 10px;
    ${theme.mediaQueries.mobile} {
      width: 18rem;
    }
  }
  input {
    border: 0px solid white;
    color: black;
    font-weight: normal;
    margin-top: 1.2rem;
  }
  input#spend_field_1,
  input#spend_field_2,
  input#spend_field_3,
  input#spend_field_4,
  input#spend_field_5,
  input#spend_field_6 {
    padding: 15px;
    width: 90%;
    ${theme.mediaQueries.mobile} {
      width: 18rem;
    }
  }
  .total {
    font-family: ${theme.typography.primaryFont.light};
    font-weight: normal;
    color: ${theme.colors.mantisGreen};
    font-size: 6rem;
    line-height: 5rem;
    margin-bottom: 2rem;
  }
  .estimatedSavingsCell {
    text-align: center;
  }
  .estimatedSavings {
    color: ${theme.colors.darkGray};
    font-size: 2.5rem;
  }
  .spendAlert {
    width: 100%;
    background-color: white;
    color: ${theme.colors.darkGray};
    text-align: center;
    font-style: italic;
    font-size: 2.2rem;
  }
  .msg {
    padding: 10px;
    border-radius: 5px;
    text-align: center;
    font-size: 2.2rem;
    margin-bottom: 5rem;
  }
  .result {
    padding-left: 10px;
    margin-left: 0px;
    color: black;
  }
  .calculator {
    padding: 20px;
    border-radius: 10px;
    margin: auto auto;
    width: 70%;
  }
  .selector {
  }
`;

const StyledTextField = styled(TextField)`
  border-radius: 10px;
  border: 1px solid ${theme.colors.gray};
  margin-bottom: 3rem;
  .MuiInputBase-root {
    border-radius: 10px;
    height: 4.5rem;
  }
`;

// ----------------------------------------
// RENDER MODULE
// ----------------------------------------
function IncentiveEstimatorModuleCAN() {
  const [output, setOutput] = useState({
    state_r: 'state_r',
    qsField1_r: 'qsField1_r',
    qsField2_r: 'qsField2_r',
    qsField3_r: 'qsField3_r',
    qsField4_r: 'qsField4_r',
    qsField5_r: 'qsField5_r',
    qsField6_r: 'qsField6_r',
    field1_r: 'field1_r',
    field2_r: 'field2_r',
    field3_r: 'field3_r',
    field4_r: 'field4_r',
    field5_r: 'field5_r',
    field6_r: 'field6_r',
    field1Label_r: 'n/a',
    field2Label_r: 'n/a',
    field3Label_r: 'n/a',
    field4Label_r: 'n/a',
    field5Label_r: 'n/a',
    field6Label_r: 'n/a',
    qualifiedLaborExpenditure_r: 'qualifiedLaborExpenditure_r',
    message_r: '',
    total_r: '0',
  });

  // ----------------------------------------
  // DEFINE INCENTIVES FOR STATE
  // ----------------------------------------
  /* void */ function defineIncentivesForState(state: string) {
    let ab = {
      abbrev: 'AB',
      field1: 22,
      field2: 34.48,
      field3: 16,
      field4: 0,
      field5: 0,
      field6: 0,
      msg: '',
      field1Label: 'Non-Labor Spend',
      field2Label: 'Provincial Labor',
      field3Label: 'Other Canadian Labor (16% on Net Labor)',
      field4Label: 'n/a',
      field5Label: 'n/a',
      field6Label: 'n/a',
    };
    let bc = {
      abbrev: 'BC',
      field1: 46.24,
      field2: 59.68,
      field3: 16,
      field4: 0,
      field5: 0,
      field6: 0,
      msg: '6% Regional and Distant Location bonuses not included in estimate.',
      field1Label: 'Provincial Labor (non-VFX/Post)',
      field2Label: 'Provincial Labor (VFX/Post)',
      field3Label: 'Other Canadian Labor (16% on Net Labor)',
      field4Label: 'n/a',
      field5Label: 'n/a',
      field6Label: 'n/a',
    };
    let mb_cos = {
      abbrev: 'MB-COS',
      field1: 53.8,
      field2: 16,
      field3: 0,
      field4: 0,
      field5: 0,
      field6: 0,
      msg: '',
      field1Label: 'Provincial Labor',
      field2Label: 'Other Canadian Labor (16% on Net Labor)',
      field3Label: 'n/a',
      field4Label: 'n/a',
      field5Label: 'n/a',
      field6Label: 'n/a',
    };
    let mb_cop = {
      abbrev: 'MB-COP',
      field1: 30,
      field2: 41.2,
      field3: 16,
      field4: 0,
      field5: 0,
      field6: 0,
      msg: '',
      field1Label: 'Non-Labor Spend',
      field2Label: 'Provincial Labor',
      field3Label: 'Other Canadian Labor (16% on Net Labor)',
      field4Label: 'n/a',
      field5Label: 'n/a',
      field6Label: 'n/a',
    };
    let nb_lb = {
      abbrev: 'NB-LB',
      field1: 49.6,
      field2: 16,
      field3: 0,
      field4: 0,
      field5: 0,
      field6: 0,
      msg: '',
      field1Label: 'Provincial Labor',
      field2Label: 'Other Canadian Labor (16% on Net Labor)',
      field3Label: 'n/a',
      field4Label: 'n/a',
      field5Label: 'n/a',
      field6Label: 'n/a',
    };
    let nb_as = {
      abbrev: 'NB-AS',
      field1: 25,
      field2: 37,
      field3: 16,
      field4: 0,
      field5: 0,
      field6: 0,
      msg: '',
      field1Label: 'Non-Labor Spend',
      field2Label: 'Provincial Labor',
      field3Label: 'Other Canadian Labor (16% on Net Labor)',
      field4Label: 'n/a',
      field5Label: 'n/a',
      field6Label: 'n/a',
    };
    let nl = {
      abbrev: 'NL',
      field1: 40,
      field2: 49.6,
      field3: 16,
      field4: 0,
      field5: 0,
      field6: 0,
      msg: '',
      field1Label: 'Non-Labor Spend',
      field2Label: 'Provincial Labor',
      field3Label: 'Other Canadian Labor (16% on Net Labor)',
      field4Label: 'n/a',
      field5Label: 'n/a',
      field6Label: 'n/a',
    };
    let ns = {
      abbrev: 'NS',
      field1: 25,
      field2: 37,
      field3: 16,
      field4: 0,
      field5: 0,
      field6: 0,
      msg: 'Up to 6% in bonuses not included in estimate.',
      field1Label: 'Non-Labor Spend',
      field2Label: 'Provincial Labor',
      field3Label: 'Other Canadian Labor',
      field4Label: 'n/a',
      field5Label: 'n/a',
      field6Label: 'n/a',
    };
    let on = {
      abbrev: 'ON',
      field1: 34.06,
      field2: 49.18,
      field3: 21.5,
      field4: 16,
      field5: 0,
      field6: 0,
      msg: '',
      field1Label: 'Provincial Labor (Non-VFX)',
      field2Label: 'Provincial Labor (VFX)',
      field3Label: 'Non-Labor Spend',
      field4Label: 'Other Canadian Labor (16% on Net Labor)',
      field5Label: 'n/a',
      field6Label: 'n/a',
    };
    let qc = {
      abbrev: 'QC',
      field1: 37,
      field2: 50.44,
      field3: 25,
      field4: 41,
      field5: 16,
      field6: 0,
      msg: '',
      field1Label: 'Provincial Labor (Non-VFX)',
      field2Label: 'Provincial Labor (VFX)',
      field3Label: 'Non-Labor Spend (Non-VFX)',
      field4Label: 'Non-Labor Spend (VFX)',
      field5Label: 'Other Canadian Labor (16% on Net Labor)',
      field6Label: 'n/a',
    };
    let ab_cc = {
      abbrev: 'AB-CC',
      field1: 0,
      field2: 22,
      field3: 22,
      field4: 0,
      field5: 0,
      field6: 25,
      msg: '',
      field1Label: 'Total Production Costs',
      field2Label: 'Provincial Labor',
      field3Label: 'Non-Labor Spend',
      field4Label: 'Other Canadian Labor',
      field5Label: 'Other Assistance (excluding tax credits)',
      field6Label: 'Qualified Labor Expenditure',
    };
    let bc_cc = {
      abbrev: 'BC-CC',
      field1: 0,
      field2: 40,
      field3: 56,
      field4: 0,
      field5: 0,
      field6: 25,
      msg:
        '12.5% bonus for qualifying BC "regional" labour when > 50% of BC principal photography is done outside Vancouver area (pro-rate number of regional days by total BC days) - 6% additional bonus for qualifying BC "distant" labour (calculated by pro-rating number of days shot in "distant location" by total BC days; must first qualify for Regional Tax Credit)',
      field1Label: 'Total Production Costs',
      field2Label: 'Provincial Labor (non-VFX/Post)',
      field3Label: 'Provincial Labor (VFX/Post)',
      field4Label: 'Other Canadian Labor',
      field5Label: 'Other Assistance (excluding tax credits)',
      field6Label: 'Qualified Labor Expenditure',
    };
    let mb_cos_cc = {
      abbrev: 'MB-COS-CC',
      field1: 0,
      field2: 45,
      field3: 0,
      field4: 0,
      field5: 0,
      field6: 25,
      msg: '',
      field1Label: 'Total Production Costs',
      field2Label: 'Provincial Labor',
      field3Label: 'Other Canadian Labor',
      field4Label: 'Other Assistance (excluding tax credits)',
      field5Label: 'n/a',
      field6Label: 'Qualified Labor Expenditure',
    };
    let mb_cop_cc = {
      abbrev: 'MB-COP-CC',
      field1: 0,
      field2: 30,
      field3: 30,
      field4: 0,
      field5: 0,
      field6: 25,
      msg: '',
      field1Label: 'Total Production Costs',
      field2Label: 'Provincial Labor',
      field3Label: 'Non-Labor Spend',
      field4Label: 'Other Canadian Labor',
      field5Label: 'Other Assistance (excluding tax credits)',
      field6Label: 'Qualified Labor Expenditure',
    };
    let nb_lb_cc = {
      abbrev: 'NB-LB-CC',
      field1: 0,
      field2: 40,
      field3: 0,
      field4: 0,
      field5: 0,
      field6: 25,
      msg: '',
      field1Label: 'Total Production Costs',
      field2Label: 'Provincial Labor',
      field3Label: 'Other Canadian Labor',
      field4Label: 'Other Assistance (excluding tax credits)',
      field5Label: 'n/a',
      field6Label: 'Qualified Labor Expenditure',
    };
    let nb_as_cc = {
      abbrev: 'NB-AS-CC',
      field1: 0,
      field2: 25,
      field3: 25,
      field4: 0,
      field5: 0,
      field6: 25,
      msg: '5% bonus for New Brunswick-owned productions',
      field1Label: 'Total Production Costs',
      field2Label: 'Provincial Labor',
      field3Label: 'Non-Labor Spend',
      field4Label: 'Other Canadian Labor',
      field5Label: 'Other Assistance (excluding tax credits)',
      field6Label: 'Qualified Labor Expenditure',
    };
    let nl_cc = {
      abbrev: 'NL-CC',
      field1: 0,
      field2: 40,
      field3: 40,
      field4: 0,
      field5: 0,
      field6: 25,
      msg: '',
      field1Label: 'Total Production Costs',
      field2Label: 'Provincial Labor',
      field3Label: 'Non-Labor Spend',
      field4Label: 'Other Canadian Labor',
      field5Label: 'Other Assistance (excluding tax credits)',
      field6Label: 'Qualified Labor Expenditure',
    };
    let ns_cc = {
      abbrev: 'NS-CC',
      field1: 0,
      field2: 25,
      field3: 25,
      field4: 0,
      field5: 0,
      field6: 25,
      msg:
        '2% bonus for productions shooting at least 51 % outside the Halifax Regional Municipality - 1% bonus for shoots longer than 30 days - 1.5% bonus for productions in which at least 60 % of principal performers, actors, and stunt performers are NS Residents - 1.5% bonus for productions that meet at least 3 NS-Content requirements',
      field1Label: 'Total Production Costs',
      field2Label: 'Provincial Labor',
      field3Label: 'Non-Labor Spend',
      field4Label: 'Other Canadian Labor',
      field5Label: 'Other Assistance (excluding tax credits)',
      field6Label: 'Qualified Labor Expenditure',
    };
    let on_cc = {
      abbrev: 'ON-CC',
      field1: 0,
      field2: 35,
      field3: 53,
      field4: 0,
      field5: 0,
      field6: 25,
      msg:
        '10% bonus for productions shooting at least 85 % outside the Greater Toronto Area',
      field1Label: 'Total Production Costs',
      field2Label: 'Provincial Labor (non-VFX)',
      field3Label: 'Provincial Labor (VFX)',
      field4Label: 'Other Canadian Labor',
      field5Label: 'Other Assistance (excluding tax credits)',
      field6Label: 'Qualified Labor Expenditure',
    };
    let qc_flgsop_cc = {
      abbrev: 'QC-FLGSOP-CC',
      field1: 0,
      field2: 40,
      field3: 0,
      field4: 0,
      field5: 0,
      field6: 25,
      msg:
        '10% bonus for films produced 25 km or more outside Montreal - 16% bonus for productions that do not receive financial assistance from certain public bodies',
      field1Label: 'Total Production Costs',
      field2Label: 'Provincial Labor',
      field3Label: 'Other Canadian Labor',
      field4Label: 'Other Assistance (excluding tax credits)',
      field5Label: 'n/a',
      field6Label: 'Qualified Labor Expenditure',
    };
    let qc_flgsff_cc = {
      abbrev: 'QC-FLGSFF-CC',
      field1: 0,
      field2: 36,
      field3: 0,
      field4: 0,
      field5: 0,
      field6: 25,
      msg:
        '10% bonus for films produced 25 km or more outside Montreal - 16% bonus for productions that do not receive financial assistance from certain public bodies',
      field1Label: 'Total Production Costs',
      field2Label: 'Provincial Labor',
      field3Label: 'Other Canadian Labor',
      field4Label: 'Other Assistance (excluding tax credits)',
      field5Label: 'n/a',
      field6Label: 'Qualified Labor Expenditure',
    };
    let qc_opop_cc = {
      abbrev: 'QC-OPOP-CC',
      field1: 0,
      field2: 32,
      field3: 42,
      field4: 0,
      field5: 0,
      field6: 25,
      msg:
        '10% bonus for films produced 25 km or more outside Montreal - 16% bonus for productions that do not receive financial assistance from certain public bodies',
      field1Label: 'Total Production Costs',
      field2Label: 'Provincial Labor (non-VFX)',
      field3Label: 'Provincial Labor (VFX)',
      field4Label: 'Other Canadian Labor',
      field5Label: 'Other Assistance (excluding tax credits)',
      field6Label: 'Qualified Labor Expenditure',
    };
    let qc_opff_cc = {
      abbrev: 'QC-OPFF-CC',
      field1: 0,
      field2: 28,
      field3: 38,
      field4: 0,
      field5: 0,
      field6: 25,
      msg:
        '10% bonus for films produced 25 km or more outside Montreal - 16% bonus for productions that do not receive financial assistance from certain public bodies',
      field1Label: 'Total Production Costs',
      field2Label: 'Provincial Labor (non-VFX)',
      field3Label: 'Provincial Labor (VFX)',
      field4Label: 'Other Canadian Labor',
      field5Label: 'Other Assistance (excluding tax credits)',
      field6Label: 'Qualified Labor Expenditure',
    };
    const data = new Map();
    data.set('AB', ab);
    data.set('BC', bc);
    data.set('MB-COS', mb_cos);
    data.set('MB-COP', mb_cop);
    data.set('NB-LB', nb_lb);
    data.set('NB-AS', nb_as);
    data.set('NL', nl);
    data.set('NS', ns);
    data.set('ON', on);
    data.set('QC', qc);
    data.set('AB-CC', ab_cc);
    data.set('BC-CC', bc_cc);
    data.set('MB-COS-CC', mb_cos_cc);
    data.set('MB-COP-CC', mb_cop_cc);
    data.set('NB-LB-CC', nb_lb_cc);
    data.set('NB-AS-CC', nb_as_cc);
    data.set('NL-CC', nl_cc);
    data.set('NS-CC', ns_cc);
    data.set('ON-CC', on_cc);
    data.set('QC-FLGSOP-CC', qc_flgsop_cc);
    data.set('QC-FLGSFF-CC', qc_flgsff_cc);
    data.set('QC-OPOP-CC', qc_opop_cc);
    data.set('QC-OPFF-CC', qc_opff_cc);
    displayIncentivesForState(data.get(state));
  }

  // ----------------------------------------
  // DISPLAY INCENTIVES FOR STATE
  // ----------------------------------------
  /* void */ function displayIncentivesForState(stateObject) {
    // ----------------------------------------
    // GET QUALIFIED SPEND VALUES FROM UI
    // AND CALCULATE TOTAL SPEND
    // ----------------------------------------
    let spend_field_1 = parseFloat(
      document
        .getElementById('spend_field_1')
        ?.value.replace(/\$/g, '')
        .replace(/,/g, ''),
    );
    let spend_field_2 = parseFloat(
      document
        .getElementById('spend_field_2')
        ?.value.replace(/\$/g, '')
        .replace(/,/g, ''),
    );
    let spend_field_3 = parseFloat(
      document
        .getElementById('spend_field_3')
        ?.value.replace(/\$/g, '')
        .replace(/,/g, ''),
    );
    let spend_field_4 = parseFloat(
      document
        .getElementById('spend_field_4')
        ?.value.replace(/\$/g, '')
        .replace(/,/g, ''),
    );
    let spend_field_5 = parseFloat(
      document
        .getElementById('spend_field_5')
        ?.value.replace(/\$/g, '')
        .replace(/,/g, ''),
    );

    spend_field_1 = !isNaN(spend_field_1) ? spend_field_1 : 0;
    spend_field_2 = !isNaN(spend_field_2) ? spend_field_2 : 0;
    spend_field_3 = !isNaN(spend_field_3) ? spend_field_3 : 0;
    spend_field_4 = !isNaN(spend_field_4) ? spend_field_4 : 0;
    spend_field_5 = !isNaN(spend_field_5) ? spend_field_5 : 0;

    /* bool */ let display_estimate = true;
    // ----------------------------------------
    if (display_estimate) {
      // ----------------------------------------
      // CALCULATE PERCENTAGES BASED ON STATE
      // ARRAY AND DISPLAY IN UI
      // ALSO DISPLAY PERCENTAGE VALUE FROM
      // ARRAY IN PARENTHESIS FOLLOWED BY A %
      // ----------------------------------------
      let savings_1 = (spend_field_1 * stateObject.field1) / 100;
      let savings_2 = (spend_field_2 * stateObject.field2) / 100;
      let savings_3 = (spend_field_3 * stateObject.field3) / 100;
      let savings_4 = (spend_field_4 * stateObject.field4) / 100;
      let savings_5 = (spend_field_5 * stateObject.field5) / 100;
      let exception = 0;
      let estimated_savings_2;
      let qle1 = 0;
      let qle2 = 0;
      let qualifiedLaborExpenditure = 0;

      switch (stateObject.abbrev) {
        case '': // SELECT JURISDICTION
          break;
        case 'AB':
          savings_1 = (spend_field_1 * (stateObject.field1 + get_ab_bonus())) / 100;
          savings_2 = (spend_field_2 * (stateObject.field2 + get_ab_bonus_aboprrf())) / 100;
          savings_3 = (spend_field_3 * stateObject.field3) / 100;
          estimated_savings_2 = savings_1 + savings_2 + savings_3;
          break;
        case 'NB-AS':
        case 'NL':
        case 'NS':
          // exception =
          //   ((spend_field_2 +
          //     spend_field_3 -
          //     (spend_field_2 * stateObject.field2) / 100) *
          //     stateObject.field3) /
          //   100;
          estimated_savings_2 = savings_1 + savings_2 + savings_3; // + exception;
          break;
        case 'MB-COP':
          savings_1 =
            (spend_field_1 * (stateObject.field1 + get_mb_cop_bonus())) / 100;
          savings_2 =
            (spend_field_2 * (stateObject.field2 + get_mb_cop_bonus_ps())) /
            100;
          savings_3 = (spend_field_3 * stateObject.field3) / 100;
          estimated_savings_2 = savings_1 + savings_2 + savings_3;
          break;
        case 'MB-COS':
          savings_1 =
            (spend_field_1 * (stateObject.field1 + get_mb_cos_bonus_ps())) /
            100;
          exception = 0;
          //(spend_field_1 +
          //  spend_field_2 -
          //  (spend_field_1 * (stateObject.field1 + get_mb_cos_bonus_ps())) /
          //    100) *
          //(stateObject.field2 / 100);
          estimated_savings_2 = savings_1 + savings_2 + exception;
          break;
        case 'NB-LB':
          // exception =
          //   ((spend_field_1 +
          //     spend_field_2 -
          //     (spend_field_1 * stateObject.field1) / 100) *
          //     stateObject.field2) /
          //   100;
          estimated_savings_2 = savings_1 + savings_2; //+ exception;
          break;
        case 'BC':
          // exception =
          //   ((spend_field_1 +
          //     spend_field_2 +
          //     spend_field_3 -
          //     (spend_field_1 * stateObject.field1) / 100 -
          //     (spend_field_2 * stateObject.field2) / 100) *
          //     stateObject.field3) /
          //   100;
          estimated_savings_2 = savings_1 + savings_2 + savings_3; //+ exception;
          break;
        case 'ON':
          // exception =
          //   ((spend_field_1 +
          //     spend_field_2 +
          //     spend_field_4 -
          //     (spend_field_1 * stateObject.field1) / 100 -
          //     (spend_field_2 * stateObject.field2) / 100) *
          //     stateObject.field4) /
          //   100;
          estimated_savings_2 = savings_1 + savings_2 + savings_3 + savings_4; //+ exception;
          break;
        case 'QC':
          // exception =
          //   ((spend_field_1 +
          //     spend_field_2 +
          //     spend_field_5 -
          //     (spend_field_1 * stateObject.field1) / 100 -
          //     (spend_field_2 * stateObject.field2) / 100) *
          //     stateObject.field5) /
          //   100;
          estimated_savings_2 =
            savings_1 + savings_2 + savings_3 + savings_4 + savings_5; //+ exception;
          break;
        case 'MB-COS-CC':
          qle1 =
            (spend_field_1 -
              spend_field_4 -
              (spend_field_2 * (stateObject.field2 + get_mb_cos_bonus())) /
                100) *
            (60 / 100);
          qle2 = spend_field_2 + spend_field_3;
          if (qle1 < qle2) {
            qualifiedLaborExpenditure = qle1;
          } else {
            qualifiedLaborExpenditure = qle2;
          }
          savings_2 =
            (spend_field_2 * (stateObject.field2 + get_mb_cos_bonus())) / 100;
          exception = (qualifiedLaborExpenditure * stateObject.field6) / 100;
          estimated_savings_2 = savings_2 + savings_3 + exception;
          break;
        case 'BC-CC':
          qle1 =
            (spend_field_1 - savings_2 - savings_3 - spend_field_5) *
            (60 / 100);
          qle2 = spend_field_2 + spend_field_3 + spend_field_4;
          if (qle1 < qle2) {
            qualifiedLaborExpenditure = qle1;
          } else {
            qualifiedLaborExpenditure = qle2;
          }
          exception = (qualifiedLaborExpenditure * stateObject.field6) / 100;
          estimated_savings_2 = savings_2 + savings_3 + exception;
          break;
        case 'AB-CC':
          savings_2 = (spend_field_2 * (stateObject.field2 + get_ab_bonus())) / 100;
          savings_3 = (spend_field_3 * (stateObject.field3 + get_ab_bonus())) / 100;
          qle1 =
            (spend_field_1 - savings_2 - savings_3 - spend_field_5) *
            (60 / 100);
          qle2 = spend_field_2 + spend_field_4;
          if (qle1 < qle2) {
            qualifiedLaborExpenditure = qle1;
          } else {
            qualifiedLaborExpenditure = qle2;
          }
          exception = (qualifiedLaborExpenditure * stateObject.field6) / 100;
          estimated_savings_2 = savings_2 + savings_3 + exception;
          break;
        case 'NB-AS-CC':
        case 'NL-CC':
        case 'NS-CC':
        case 'ON-CC':
        case 'QC-OPOP-CC':
          qle1 =
            (spend_field_1 - savings_2 - savings_3 - spend_field_5) *
            (60 / 100);
          qle2 = spend_field_2 + spend_field_4;
          if (qle1 < qle2) {
            qualifiedLaborExpenditure = qle1;
          } else {
            qualifiedLaborExpenditure = qle2;
          }
          exception = (qualifiedLaborExpenditure * stateObject.field6) / 100;
          estimated_savings_2 = savings_2 + savings_3 + exception;
          break;
        case 'MB-COP-CC':
          savings_2 =
            (spend_field_2 * (stateObject.field2 + get_mb_cop_bonus())) / 100;
          savings_3 =
            (spend_field_3 * (stateObject.field3 + get_mb_cop_bonus())) / 100;
          qle1 =
            (spend_field_1 - savings_2 - savings_3 - spend_field_5) *
            (60 / 100);
          qle2 = spend_field_2 + spend_field_4;
          if (qle1 < qle2) {
            qualifiedLaborExpenditure = qle1;
          } else {
            qualifiedLaborExpenditure = qle2;
          }
          exception = (qualifiedLaborExpenditure * stateObject.field6) / 100;
          estimated_savings_2 = savings_2 + savings_3 + exception;
          break;
        case 'QC-OPFF-CC':
          qle1 =
            (spend_field_1 - savings_2 - savings_3 - spend_field_5) *
            (60 / 100);
          qle2 = spend_field_2 + spend_field_3 + spend_field_4;
          if (qle1 < qle2) {
            qualifiedLaborExpenditure = qle1;
          } else {
            qualifiedLaborExpenditure = qle2;
          }
          exception = (qualifiedLaborExpenditure * stateObject.field6) / 100;
          estimated_savings_2 = savings_2 + savings_3 + exception;
          break;
        case 'QC-FLGSOP-CC':
        case 'NB-LB-CC':
        case 'QC-FLGSFF-CC':
          qle1 = (spend_field_1 - savings_2 - spend_field_4) * (60 / 100);
          qle2 = spend_field_2 + spend_field_3;
          if (qle1 < qle2) {
            qualifiedLaborExpenditure = qle1;
          } else {
            qualifiedLaborExpenditure = qle2;
          }
          exception = (qualifiedLaborExpenditure * stateObject.field6) / 100;
          estimated_savings_2 = savings_2 + savings_3 + exception;
          break;
        default:
          break;
      }
      // ----------------------------------------
      // DISPLAY ESTIMATED TOTAL SAVINGS
      // ----------------------------------------

      let percentage_1 = stateObject.field1;
      let percentage_2 = stateObject.field2;
      let percentage_3 = stateObject.field3;
      let percentage_4 = stateObject.field4;
      let percentage_5 = stateObject.field5;
      let percentage_6 = stateObject.field6;

      // Reflect updated percentages in the UI if user checks boxes

      switch (stateObject.abbrev) {
        case 'AB':
          percentage_1 = percentage_1 + get_ab_bonus();
          percentage_2 = (percentage_2 + get_ab_bonus_aboprrf()).toFixed(1);
          break;
        case 'AB-CC':
          percentage_2 = percentage_2 + get_ab_bonus();
          percentage_3 = percentage_3 + get_ab_bonus();
          break;
        case 'MB-COP':
          percentage_1 = percentage_1 + get_mb_cop_bonus();
          percentage_2 = percentage_2 + get_mb_cop_bonus_ps();
          break;
        case 'MB-COP-CC':
          percentage_2 = percentage_2 + get_mb_cop_bonus();
          percentage_3 = percentage_3 + get_mb_cop_bonus();
          break;
        case 'MB-COS':
          percentage_1 = (percentage_1 + get_mb_cos_bonus_ps()).toFixed(1);
          break;
        case 'MB-COS-CC':
          percentage_2 = percentage_2 + get_mb_cos_bonus();
          break;
      }

      setOutput({
        ...output,
        state_r: stateObject.abbrev,
        qsField1_r: addComma(spend_field_1),
        qsField2_r: addComma(spend_field_2),
        qsField3_r: addComma(spend_field_3),
        qsField4_r: addComma(spend_field_4),
        qsField5_r: addComma(spend_field_5),
        qsField6_r: addComma(exception),
        field1_r: savings_1
          ? savings_1.toLocaleString(undefined, { minimumFractionDigits: 0 }) +
            ' (' +
            percentage_1 +
            '%)'
          : '0',
        field2_r: savings_2
          ? savings_2.toLocaleString(undefined, { minimumFractionDigits: 0 }) +
            ' (' +
            percentage_2 +
            '%)'
          : '0',
        field3_r: savings_3
          ? savings_3.toLocaleString(undefined, { minimumFractionDigits: 0 }) +
            ' (' +
            percentage_3 +
            '%)'
          : '0',
        field4_r: savings_4
          ? savings_4.toLocaleString(undefined, { minimumFractionDigits: 0 }) +
            ' (' +
            percentage_4 +
            '%)'
          : '0',
        field5_r: savings_5
          ? savings_5.toLocaleString(undefined, { minimumFractionDigits: 0 }) +
            ' (' +
            percentage_5 +
            '%)'
          : '0',
        field6_r: exception
          ? exception.toLocaleString(undefined, { minimumFractionDigits: 0 }) +
            ' (' +
            percentage_6 +
            '%)'
          : '0',
        field1Label_r: stateObject.field1Label,
        field2Label_r: stateObject.field2Label,
        field3Label_r: stateObject.field3Label,
        field4Label_r: stateObject.field4Label,
        field5Label_r: stateObject.field5Label,
        field6Label_r: stateObject.field6Label,
        qualifiedLaborExpenditure_r: addComma(qualifiedLaborExpenditure),
        message_r: stateObject.msg,
        total_r: estimated_savings_2
          ? estimated_savings_2.toLocaleString(undefined, {
              minimumFractionDigits: 0,
            })
          : '0',
      });
      spend_field_1 &&
        (document.getElementById('spend_field_1').value = addComma(
          spend_field_1,
        ));
      spend_field_2 &&
        (document.getElementById('spend_field_2').value = addComma(
          spend_field_2,
        ));
      spend_field_3 &&
        (document.getElementById('spend_field_3').value = addComma(
          spend_field_3,
        ));
      spend_field_4 &&
        (document.getElementById('spend_field_4').value = addComma(
          spend_field_4,
        ));
      spend_field_5 &&
        (document.getElementById('spend_field_5').value = addComma(
          spend_field_5,
        ));
    }
  }

  // ----------------------------------------
  // GET AB BONUS
  // ----------------------------------------
  /* int */ function get_ab_bonus() {
    let ab_bonus = 0;
    let ab_option = document.getElementsByName('ab_option');
    if (ab_option != undefined) {
      for (let i = 0, length = ab_option.length; i < length; i++) {
        if (ab_option[i].checked) {
          if (ab_option[i].value == 'ab_abop_rrf') {
            ab_bonus = ab_bonus + 8;
          }
        }
      }
      return ab_bonus;
    }
    return '';
  }

  // ----------------------------------------
  // GET AB BONUS ABOP RRF
  // ----------------------------------------
  /* int */ function get_ab_bonus_aboprrf() {
    let ab_bonus_aboprrf = 0;
    let ab_option = document.getElementsByName('ab_option');
    if (ab_option != undefined) {
      for (let i = 0, length = ab_option.length; i < length; i++) {
        if (ab_option[i].checked) {
          if (ab_option[i].value == 'ab_abop_rrf') {
            ab_bonus_aboprrf = ab_bonus_aboprrf + 6.72;
          }
        }
      }
      return ab_bonus_aboprrf;
    }
    return '';
  }

  // ----------------------------------------
  // GET MB COS BONUS
  // ----------------------------------------
  /* int */ function get_mb_cos_bonus() {
    let mb_cos_bonus = 0;
    let mb_cos_option = document.getElementsByName('mb_cos_option');
    if (mb_cos_option != undefined) {
      for (let i = 0, length = mb_cos_option.length; i < length; i++) {
        if (mb_cos_option[i].checked) {
          if (mb_cos_option[i].value == 'regional') {
            mb_cos_bonus = mb_cos_bonus + 5;
          }
          if (mb_cos_option[i].value == 'producer') {
            mb_cos_bonus = mb_cos_bonus + 5;
          }
          if (mb_cos_option[i].value == 'frequent') {
            mb_cos_bonus = mb_cos_bonus + 10;
          }
        }
      }
      return mb_cos_bonus;
    }
    return '';
  }

  // ----------------------------------------
  // GET MB COS BONUS
  // ----------------------------------------
  /* int */ function get_mb_cos_bonus_ps() {
    let mb_cos_bonus = 0;
    let mb_cos_option = document.getElementsByName('mb_cos_option');
    if (mb_cos_option != undefined) {
      for (let i = 0, length = mb_cos_option.length; i < length; i++) {
        if (mb_cos_option[i].checked) {
          if (mb_cos_option[i].value == 'regional') {
            mb_cos_bonus = mb_cos_bonus + 4.2;
          }
          if (mb_cos_option[i].value == 'producer') {
            mb_cos_bonus = mb_cos_bonus + 4.2;
          }
          if (mb_cos_option[i].value == 'frequent') {
            mb_cos_bonus = mb_cos_bonus + 8.4;
          }
        }
      }
      return mb_cos_bonus;
    }
    return '';
  }

  // ----------------------------------------
  // GET MB COP BONUS
  // ----------------------------------------
  /* int */ function get_mb_cop_bonus() {
    let mb_cop_bonus = 0;
    let mb_cop_option = document.getElementsByName('mb_cop_option');
    if (mb_cop_option != undefined) {
      for (let i = 0, length = mb_cop_option.length; i < length; i++) {
        if (mb_cop_option[i].checked) {
          if (mb_cop_option[i].value == 'mb_production_company') {
            mb_cop_bonus = mb_cop_bonus + 8;
          }
        }
      }
      return mb_cop_bonus;
    }
    return '';
  }

  // ----------------------------------------
  // GET MB COP BONUS PS
  // ----------------------------------------
  /* int */ function get_mb_cop_bonus_ps() {
    let mb_cop_bonus = 0;
    let mb_cop_option = document.getElementsByName('mb_cop_option');
    if (mb_cop_option != undefined) {
      for (let i = 0, length = mb_cop_option.length; i < length; i++) {
        if (mb_cop_option[i].checked) {
          if (mb_cop_option[i].value == 'mb_production_company') {
            mb_cop_bonus = mb_cop_bonus + 6.72;
          }
        }
      }
      return mb_cop_bonus;
    }
    return '';
  }

  // ----------------------------------------
  // GET PARAM
  // ----------------------------------------
  function get_param(val) {
    let result = '',
      tmp = [];
    location.search
      .substr(1)
      .split('&')
      .forEach(function(item) {
        tmp = item.split('=');
        if (tmp[0] === val) result = decodeURIComponent(tmp[1]);
      });
    return result;
  }

  // ----------------------------------------
  // ADD COMMA
  // ----------------------------------------
  /* number */ function addComma(num) {
    num += '';
    num = num.replace(',', '');
    num = num.replace(',', '');
    num = num.replace(',', '');
    num = num.replace(',', '');
    num = num.replace(',', '');
    num = num.replace(',', '');
    let x = num.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '';
    let rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) x1 = x1.replace(rgx, '$1' + ',' + '$2');
    return '$' + x1 + x2;
  }

  // ----------------------------------------
  // HANLDE MENU STYLE
  // ----------------------------------------
  function handleMenuStyle(menu: HTMLSelectElement) {
    if (
      menu.getAttribute('style') == 'color: black; background-color: white;'
    ) {
      menu.setAttribute('style', 'color: white; background-color: #868686;');
    } else {
      menu.setAttribute('style', 'color: black; background-color: white;');
    }
  }

  return (
    <StyledContainer>
      <div id="controls">
        <form>
          <div id="controlsInner">
            <h1>
              {get_param('mode') == 'cc'
                ? 'Enter qualified Canadian Content spend only'
                : 'Enter qualified Production Service spend only'}
            </h1>
            <div className="option">
              {get_param('mode') !== 'cc' && (
                <>
                  <div className="selector">
                    <select
                      name="state"
                      id="state"
                      onMouseOut={event => handleMenuStyle(event.target)}
                      onMouseOver={event => handleMenuStyle(event.target)}
                      onChange={event =>
                        event.target[event.target.options.selectedIndex]
                          .value != ''
                          ? defineIncentivesForState(
                              event.target[event.target.options.selectedIndex]
                                .value,
                            )
                          : null
                      }
                      style={{ color: 'black', backgroundColor: 'white' }}
                    >
                      <option value="" selected="selected">
                        SELECT JURISDICTION
                      </option>
                      <option value="AB">Alberta</option>
                      <option value="BC">British Columbia</option>
                      <option value="MB-COS">
                        Manitoba - Cost of Salaries
                      </option>
                      <option value="MB-COP">
                        Manitoba - Cost of Production
                      </option>
                      <option value="NB-LB">New Brunswick - Labor Based</option>
                      <option value="NB-AS">New Brunswick - All Spend</option>
                      <option value="NL">Newfoundland</option>
                      <option value="NS">Nova Scotia</option>
                      <option value="ON">Ontario</option>
                      <option value="QC">Quebec</option>
                    </select>
                    <br />
                  </div>
                </>
              )}
              {get_param('mode') == 'cc' && (
                <>
                  <div className="selector">
                    <select
                      name="state"
                      id="state"
                      onMouseOut={event => handleMenuStyle(event.target)}
                      onMouseOver={event => handleMenuStyle(event.target)}
                      onChange={event =>
                        event.target[event.target.options.selectedIndex]
                          .value != ''
                          ? defineIncentivesForState(
                              event.target[event.target.options.selectedIndex]
                                .value,
                            )
                          : null
                      }
                      style={{ color: 'black', backgroundColor: 'white' }}
                    >
                      <option value="" selected="selected">
                        SELECT JURISDICTION
                      </option>
                      <option value="AB-CC">Alberta</option>
                      <option value="BC-CC">British Columbia</option>
                      <option value="MB-COS-CC">
                        Manitoba - Cost of Salaries
                      </option>
                      <option value="MB-COP-CC">
                        Manitoba - Cost of Production
                      </option>
                      <option value="NB-LB-CC">
                        New Brunswick - Labor Based
                      </option>
                      <option value="NB-AS-CC">
                        New Brunswick - All Spend
                      </option>
                      <option value="NL-CC">Newfoundland</option>
                      <option value="NS-CC">Nova Scotia</option>
                      <option value="ON-CC">Ontario</option>
                      <option value="QC-FLGSOP-CC">
                        Quebec - French language - Giant screen -
                        OriginalProduction
                      </option>
                      <option value="QC-FLGSFF-CC">
                        Quebec - French language - Giant screen - Foreign Format
                      </option>
                      <option value="QC-OPOP-CC">
                        Quebec - Other Production - Original Production
                      </option>
                      <option value="QC-OPFF-CC">
                        Quebec - Other Production - Foreign Format
                      </option>
                    </select>
                    <br />
                  </div>
                </>
              )}
            </div>
            {output.field1Label_r != 'n/a' && (
              <StyledTextField
                type="text"
                id="spend_field_1"
                placeholder={
                  output.qsField1_r != '$0'
                    ? output.field1Label_r
                    : '$0 ' + output.field1Label_r
                }
                onFocus={event => (event.target.value = '')}
                onChange={event => defineIncentivesForState(output.state_r)}
              />
            )}
            {output.field2Label_r != 'n/a' && (
              <StyledTextField
                type="text"
                id="spend_field_2"
                placeholder={
                  output.qsField2_r != '$0'
                    ? output.field2Label_r
                    : '$0 ' + output.field2Label_r
                }
                onFocus={event => (event.target.value = '')}
                onChange={event => defineIncentivesForState(output.state_r)}
              />
            )}
            {output.field3Label_r != 'n/a' && (
              <StyledTextField
                type="text"
                id="spend_field_3"
                placeholder={
                  output.qsField3_r != '$0'
                    ? output.field3Label_r
                    : '$0 ' + output.field3Label_r
                }
                onFocus={event => (event.target.value = '')}
                onChange={event => defineIncentivesForState(output.state_r)}
              />
            )}
            {output.field4Label_r != 'n/a' && (
              <StyledTextField
                type="text"
                id="spend_field_4"
                placeholder={
                  output.qsField4_r != '$0'
                    ? output.field4Label_r
                    : '$0 ' + output.field4Label_r
                }
                onFocus={event => (event.target.value = '')}
                onChange={event => defineIncentivesForState(output.state_r)}
              />
            )}
            {output.field5Label_r != 'n/a' && (
              <StyledTextField
                type="text"
                id="spend_field_5"
                placeholder={
                  output.qsField5_r != '$0'
                    ? output.field5Label_r
                    : '$0 ' + output.field5Label_r
                }
                onFocus={event => (event.target.value = '')}
                onChange={event => defineIncentivesForState(output.state_r)}
              />
            )}
            {output.field6Label_r != 'n/a' && (
              <>
                {output.field6Label_r}
                <br />
                {output.qualifiedLaborExpenditure_r}
              </>
            )}
          </div>
        </form>
      </div>
      <div id="results">
        <div id="resultsInner">
          <h1>Incentive Amount</h1>
          <div className="option">
            {output.state_r == 'AB' || output.state_r == 'AB-CC' ? (
              <div id="ab_option">
                <p>
                  <input
                    type="checkbox"
                    name="ab_option"
                    value="ab_abop_rrf"
                    onChange={event => defineIncentivesForState(output.state_r)}
                  />{' '}
                  AB-owned Productions/<br/>&nbsp;&nbsp;&nbsp;Rural & Remote Filming (+8%) <br />
                </p>
              </div>
            ) : (
              ''
            )}
            {output.state_r == 'MB-COS' || output.state_r == 'MB-COS-CC' ? (
              <div id="mb_cos_option">
                <p>
                  <input
                    type="checkbox"
                    name="mb_cos_option"
                    value="regional"
                    onChange={event => defineIncentivesForState(output.state_r)}
                  />{' '}
                  Regional (+5%) <br />
                  <input
                    type="checkbox"
                    name="mb_cos_option"
                    value="producer"
                    onChange={event => defineIncentivesForState(output.state_r)}
                  />{' '}
                  MB Producer (+5%) <br />
                  <input
                    type="checkbox"
                    name="mb_cos_option"
                    value="frequent"
                    onChange={event => defineIncentivesForState(output.state_r)}
                  />{' '}
                  Frequent Filming (+10%)
                </p>
              </div>
            ) : (
              ''
            )}
            {output.state_r == 'MB-COP' || output.state_r == 'MB-COP-CC' ? (
              <div id="mb_cop_option">
                <p>
                  <input
                    type="checkbox"
                    name="mb_cop_option"
                    value="mb_production_company"
                    onChange={event => defineIncentivesForState(output.state_r)}
                  />{' '}
                  MB Production Company (+8%) <br />
                </p>
              </div>
            ) : (
              ''
            )}
          </div>
          {output.field1Label_r != 'n/a' && (
            <p id="field_1_p">
              {' '}
              <hr />${output.field1_r} {output.field1Label_r}{' '}
            </p>
          )}
          {output.field2Label_r != 'n/a' && (
            <p id="field_2_p">
              {' '}
              <hr />${output.field2_r} {output.field2Label_r}{' '}
            </p>
          )}
          {output.field3Label_r != 'n/a' && (
            <p id="field_3_p">
              {' '}
              <hr />${output.field3_r} {output.field3Label_r}{' '}
            </p>
          )}
          {output.field4Label_r != 'n/a' && (
            <p id="field_4_p">
              {' '}
              <hr />${output.field4_r} {output.field4Label_r}{' '}
            </p>
          )}
          {output.field5Label_r != 'n/a' && (
            <p id="field_5_p">
              {' '}
              <hr />${output.field5_r} {output.field5Label_r}{' '}
            </p>
          )}
          {output.field6Label_r != 'n/a' && (
            <p id="field_6_p">
              {' '}
              <hr />${output.field6_r} {output.field6Label_r}{' '}
            </p>
          )}
          {output.state_r != 'state_r' && <hr />}
        </div>
      </div>
      <div id="bottom">
        <div className="estimatedSavingsCell">
          <div className="estimatedSavings">Estimated Savings</div>
          <div className="total">${output.total_r}</div>
        </div>
        <div>
          <div id="messageDiv" className="msg">
            {output.message_r}
          </div>
        </div>
      </div>
    </StyledContainer>
  );
}

export default React.memo(IncentiveEstimatorModuleCAN);
